import YSF from '@neysf/qiyu-web-sdk'
import cookie from 'react-cookies'
import moment from 'moment'

class YSFClass {
  static ysf = null
  // 初始化方法，只会初始化一次
  static async init(open = false) {
    this.ysf = await YSF.init('671dddfa2ffec8464a9bc6147ef86b76', {
      templateId: 8139011,
      subdomain: 1,
    })
    if (open) {
      if (cookie.load('showKF') != 'true') {
        this.ysf.open()
        let expiresTime = moment().add(1, 'days').toDate()
        cookie.save('showKF', true, {
          expires: expiresTime,
        })
      }
    }
  }
}

export default YSFClass
